import { InfoMessageType } from "src/Components/InfoBar/InfoBar";
import { useEffect, useMemo } from "react";
import { logger } from "src/Utils/LoggerService/LoggerService";
import { useGetTechicalDocuments } from "src/Utils/Hooks/Downloads/useGetTechicalDocuments";
import DocumentsDetails from "../Documents/DocumentsDetails";
import Loader from "src/Components/Loader/Loader";
import { Config } from "src/Utils/ConfigService/LoadConfig";
interface ITechnicalDocumentsParams {
    setInfo: (message: string, type: InfoMessageType) => void;
}

const TechnicalDocuments: React.FC<ITechnicalDocumentsParams> = ({setInfo }) => {
    const { data, loading, error } = useGetTechicalDocuments()
    const filteredList = useMemo(() => {
        const hiddenDocs: string[] = Config.GetConfigData().hiddenTechnicalDocuments ?? [];
        return data && data.filter(doc => !hiddenDocs.includes(doc.displayName));
    }, [data])
    useEffect(() => {
        if (error) {
            logger.logError(`Failed to get techinical documents.`)
            setInfo(error, InfoMessageType.error);
        }
    }, [error, setInfo])
    return (
        <>
            {loading && <Loader />}
            {filteredList &&
               <DocumentsDetails data={filteredList} title="Technical Documentation" id="tech-doc"/>
            }
        </>
    )
}
export default TechnicalDocuments;